import { load_storage } from "./localstorage";

function convertToPlainObject(screen) {
  const plainObject = {};
  for (const prop in screen) {
    plainObject[prop] = screen[prop];
  }

  return plainObject;
}

const fetchStats = async (type) => {
  console.log("stats event recieved");
  let screens;
  if ("getScreenDetails" in window) {
    const screenDetails = await window.getScreenDetails();
    screens = screenDetails.screens;
    console.log(screenDetails, screens);
  }
  screens = screens?.map((screen) => convertToPlainObject(screen));
  const token = load_storage("access_token");
  const body = JSON.stringify({
    version: process.env.REACT_APP_VERSION,
    os: navigator.platform,
    screens,
    path: window.location.href,
    type,
  });
  if (token) {
    fetch(`${process.env.REACT_APP_API_BASE_URL}api/stats`, {
      headers: {
        Authorization: token,
      },
      body,
      method: "POST",
    }).catch((e) => {
      console.log(e.message);
    });
  }
};

export default fetchStats;
